export const TWEET_HASHTAGS = "ctf,hackinglab";
export const TWEET_URL = "https://shop.hacking-lab.com";
export const TWEET_VIA = "@TheHackingLab @Compasssecurity";
